const baseUrl = process.env.VUE_APP_BASE_URL;
export default {
  url: baseUrl+"/api/",
  upload_url: baseUrl+"/Api/Common/upload",
  url_no: baseUrl+"/",
};
